import {
  TiersMapType,
  PartnerTiersType,
} from 'app/developer-v3/types/partnerDashboard';

export const PARTNER_TIERS = [
  {
    key: PartnerTiersType.BETA,
    label: 'Beta',
    next: PartnerTiersType.BRONZE,
    prev: null,
    perks: [],
  },
  {
    key: PartnerTiersType.BRONZE,
    label: 'Bronze',
    next: PartnerTiersType.SILVER,
    prev: PartnerTiersType.BETA,
    perks: [
      'Frontline customer support',
      'Developer support',
      'Access to integration health data',
      'Dedicated page in Zapier’s App Directory',
      'Access to Zapier Partner Sandbox',
      'Access to Zapier Issue Manager',
    ],
  },
  {
    key: PartnerTiersType.SILVER,
    label: 'Silver',
    next: PartnerTiersType.GOLD,
    prev: PartnerTiersType.BRONZE,
    perks: [
      'Get leads from Zapier’s App Directory',
      'Be a featured integration in the Zapier App Directory',
      'Integration announcements on the Zapier Community',
      'Spotlight in the weekly Zapier blog email newsletter',
      'Featured flyover in "Best of" blog post',
    ],
  },
  {
    key: PartnerTiersType.GOLD,
    label: 'Gold',
    next: PartnerTiersType.PLATINUM,
    prev: PartnerTiersType.SILVER,
    perks: ['Integration announcements on the Zapier Product Blog'],
  },
  {
    key: PartnerTiersType.PLATINUM,
    label: 'Platinum',
    next: null,
    prev: PartnerTiersType.GOLD,
    perks: [
      '1:1 integration advocacy session',
      'Prioritized inclusion in Zapier-initiated co-marketing efforts',
      'Priority developer support',
    ],
  },
];

export const TIERS_MAP: TiersMapType = PARTNER_TIERS.reduce(
  (map, tier) => ({ ...map, [tier.key]: tier }),
  {}
);

export const HEALTH_SCORE_MAP = {
  NA: 'Not Enough Data',
  POOR: 'Poor',
  HEALTHY: 'Healthy',
  EXCEPTIONAL: 'Exceptional',
};
const HEALTH_MESSAGES = {
  untested: `You'll need at least 20 users before we can calculate your Health Score.`,
  poorMove: 'Get to healthy or above to move to next level.',
  poorMaintain: 'Get to healthy or above to maintain your current level.',
  congratsMove:
    'Congrats! Keep your health score at healthy or above to move to the next level.',
  congratsMaintain:
    'Congrats! Your health score qualifies you to stay in Platinum.',
};
export const HEALTH_TIER_MESSAGES = {
  BETA: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMove,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  BRONZE: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMove,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  SILVER: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMaintain,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  GOLD: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMaintain,
    HEALTHY: HEALTH_MESSAGES.congratsMove,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMove,
  },
  PLATINUM: {
    NA: HEALTH_MESSAGES.untested,
    POOR: HEALTH_MESSAGES.poorMaintain,
    HEALTHY: HEALTH_MESSAGES.congratsMaintain,
    EXCEPTIONAL: HEALTH_MESSAGES.congratsMaintain,
  },
};
